const stats = [
  { val: '500+', label: 'Tamamlanan Proje', desc: 'İzmir genelinde başarıyla teslim edilen uygulama' },
  { val: '10+', label: 'Yıllık Deneyim', desc: 'Sektörde güvenilir ve köklü hizmet geçmişi' },
  { val: '11', label: 'Farklı Sistem', desc: 'Her ihtiyaca özel geniş ürün yelpazesi' },
  { val: '%100', label: 'Ücretsiz Keşif', desc: 'Tüm İzmir ilçelerinde yerinde ölçüm ve danışmanlık' },
];

const features = [
  { icon: 'ri-medal-2-line', title: 'Sertifikalı Malzeme', desc: 'Alüminyum profil ve teknik kumaşlarda yalnızca belgelenmiş, uzun ömürlü ürünler.' },
  { icon: 'ri-team-line', title: 'Uzman Ekip', desc: 'Her projede deneyimli montaj ekibi, titiz işçilik ve zamanında teslim.' },
  { icon: 'ri-price-tag-3-line', title: 'Şeffaf Fiyat', desc: 'Keşif sonrası net teklif, gizli maliyet yok, sürpriz fatura yok.' },
  { icon: 'ri-customer-service-2-line', title: 'Satış Sonrası Destek', desc: 'Montaj tamamlandıktan sonra da yanınızdayız. Bakım ve onarım hizmeti.' },
];

export default function WhyUsSection() {
  return (
    <section className="bg-[#0f1923]">

      {/* Stats band */}
      <div className="border-b border-white/8">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-14 md:py-20">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4">
            {stats.map((s, i) => (
              <div key={i} className={`${i < 3 ? 'md:border-r md:border-white/10 md:pr-8' : ''}`}>
                <div className="font-heading text-4xl md:text-5xl text-[#d4a853] mb-2">{s.val}</div>
                <div className="font-body text-white text-sm font-semibold mb-1">{s.label}</div>
                <div className="font-body text-white/35 text-xs leading-relaxed">{s.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Main content */}
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

          {/* Left image */}
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="/images/pages/uzman-ekip.webp"
                alt="İzmirde Tenteci Uzman Ekip"
                loading="lazy" decoding="async"
                className="w-full h-80 md:h-[500px] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0f1923]/60 to-transparent"></div>
            </div>
            {/* Floating card */}
            <div className="absolute -bottom-6 -right-4 md:-right-8 bg-[#d4a853] rounded-xl p-5 max-w-[180px]">
              <div className="font-heading text-3xl text-[#0f1923]">10+</div>
              <div className="font-body text-[#0f1923]/70 text-xs mt-1 leading-snug">Yıllık Sektör Deneyimi</div>
            </div>
          </div>

          {/* Right text */}
          <div className="order-1 lg:order-2">
            <p className="font-body text-[#d4a853] text-xs font-semibold tracking-[0.25em] uppercase mb-5">— Neden Biz</p>
            <h2 className="font-heading text-4xl md:text-5xl text-white leading-tight mb-6">
              Neden <br />
              <span className="text-[#d4a853] italic">İzmirde Tenteci?</span>
            </h2>
            <p className="font-body text-white/50 text-sm leading-relaxed mb-10 max-w-md">
              İzmir tente ve pergola sektöründe yılların verdiği deneyimle, her projeye özel çözümler üretiyoruz. Uygun fiyat, hızlı kurulum ve satış sonrası destek ile fark yaratıyoruz.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
              {features.map((f) => (
                <div key={f.title} className="bg-white/5 border border-white/8 rounded-xl p-5 hover:border-[#d4a853]/30 transition-colors">
                  <div className="w-9 h-9 flex items-center justify-center bg-[#d4a853]/15 rounded-lg mb-3">
                    <i className={`${f.icon} text-[#d4a853] text-lg`}></i>
                  </div>
                  <h3 className="font-body text-white text-sm font-semibold mb-1.5">{f.title}</h3>
                  <p className="font-body text-white/40 text-xs leading-relaxed">{f.desc}</p>
                </div>
              ))}
            </div>

            <a
              href="tel:05362771709"
              className="inline-flex items-center gap-2 bg-[#d4a853] text-[#0f1923] font-body font-semibold text-sm px-7 py-3.5 rounded-lg hover:bg-[#e8c47a] transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-fill"></i>
              Ücretsiz Keşif İçin Ara
            </a>
          </div>

        </div>
      </div>
    </section>
  );
}
